// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge__receipt-status[data-v-eb253186]{display:flex;align-items:center;font-size:12px;padding:12px;width:-webkit-max-content;width:-moz-max-content;width:max-content}.icon-can_download[data-v-eb253186]{cursor:pointer}.icon-can-not_download[data-v-eb253186]{opacity:.4}", ""]);
// Exports
module.exports = exports;
